import React from "react";
import { useState, useRef, useEffect } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

export default function SplitButton({ label, items=[], companyId, setCompanySelected, setThread_id, GetHistoryThreads }) {
  const [open, setOpen]=useState(false);
  const anchorRef=useRef(null);
  const [selectedCompanyId, setSelectedCompanyId]=useState(null);

  const companyDict = items.reduce((acc, item) => {
    acc[item.company_id] = item.business_name;
    return acc;
  }, {});

  const handleMenuItemClick = (company_id) => {
    setSelectedCompanyId(company_id);
    setCompanySelected(company_id)
    setThread_id(null)
    GetHistoryThreads(company_id)
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    setSelectedCompanyId(companyId);
  }, [companyId]);

  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label={label}
      >
        <Button
            sx={{
                backgroundColor: 'rgb(85, 94, 238)',
                height: '34px',
                boxShadow: 'none',
                '&:hover': {
                backgroundColor: 'rgb(85, 94, 238)',
                boxShadow: 'none',
                },
                '&:focus': {
                boxShadow: 'none',
                },
            }}
        >{companyDict[selectedCompanyId] || label}</Button>
        <Button
            sx={{
                backgroundColor: 'rgb(85, 94, 238)',
                boxShadow: 'none',
                '&:hover': {
                backgroundColor: 'rgb(85, 94, 238)',
                boxShadow: 'none',
                },
                '&:focus': {
                boxShadow: 'none',
                },
            }}
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="Selecciona una opción"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {items.map((option, index) => (
                    <MenuItem
                      sx={{ fontSize: "1rem", color: "#000000", fontWeight: 300 }}
                      key={option.company_id}
                      selected={option.company_id === companyId}
                      onClick={(event) => handleMenuItemClick(option.company_id)}
                    >
                      {option.business_name.toUpperCase()}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}